module.exports = __webpack_public_path__ + "img/bg-img-1-dark.eca9b0df.png";